import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import Cookie from "js-cookie";
export function SecureRoute({ children }) {
  const location = useLocation();
  const currentUser = Cookie.get("currentUser");
  const gettoken = Cookie.get("token")

  // Check if currentUser and gettoken exist, otherwise redirect to login
  if (!currentUser || !gettoken) {
      // Redirect them to the /login page, but save the current location they were
      // trying to go to when they were redirected. This allows us to send them
      // along to that page after they login, which is a nicer user experience
      // than dropping them off on the home page.
      return <Navigate to="/" state={{ from: location }} replace />;
  }

  // If the user is authenticated and has the required data, render the children components
  return React.Children.map(children, child => React.cloneElement(child, { location })); //state data was not available in the props so added this code
}